import { Capacitor } from '@capacitor/core';
import {
    AppUpdate,
    AppUpdateAvailability,
    AppUpdateResultCode
} from '@capawesome/capacitor-app-update';

export default {
    name: 'AppVersionModal',

    computed: {
        appVersionMinimal() {
            return this.$store.getters.getAppVersionMinimal;
        },

        isAppVersionOutdated() {
            return Capacitor.isNativePlatform() && this.$store.getters.getIsAppVersionOutdated;
        }
    },

    methods: {
        async updateApp() {
            if (Capacitor.isNativePlatform()) {
                if (Capacitor.getPlatform() === 'android') {
                    const { immediateUpdateAllowed, updateAvailability } =
                        await AppUpdate.getAppUpdateInfo();
                    if (updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
                        return;
                    }

                    if (immediateUpdateAllowed) {
                        const { code } = await AppUpdate.performImmediateUpdate();
                        if (code === AppUpdateResultCode.OK) {
                            this.$store.dispatch('setAppVersion');
                        }
                    }
                } else if (Capacitor.getPlatform() === 'ios') {
                    await AppUpdate.openAppStore({ appId: '1627690284' });
                }
            }
        }
    }
};
